﻿import { Component, Inject, Input } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../application"
import { ServiceCaseService } from "../../services/fiqassistApi/serviceCaseService"
import { AuthenticationService } from "../../services/authenticationService"
import { Request } from "../../models/serviceCase"
import { CaseFileData } from "../../models/file"
import { RequestBase } from "./requestBase";
import { ServiceCaseEdit, CaseType } from "../general/serviceCaseEdit";
import { FeedbackStatusLink } from "../general/conversationentry";
import { IsProcessingService } from "../../services/isProcessingService";
import { CacheService } from "../../services/cache";
import { StatusButton } from "../general/statusbuttons";
import { TranslationService } from "../../services/TranslationService";
import { ConversationSettings } from "../../constants";
import { LogService } from "../../services/logService";
import { DialogService } from "../../services/dialogService";
import { SaveDialog } from "../general/savedialog";
import { ServiceUtils } from "../../services/serviceBase";
import { AuthorizationService } from "../../services/authorizationService";
import { FileService } from "../../services/fiqassistApi/FileService";
import { UserService } from "../../services/fiqassistApi/userService";

@Component({
    module: FIQAssist,
    selector: "requestEdit",
    templateUrl: ServiceCaseEdit.template,
    require: {
        application: "^application",
        Base: "^requestBase"
    }
})
class RequestEdit extends ServiceCaseEdit<Request> {
    protected application: Application;
    protected Base: RequestBase;
    @Input() protected $router: ng.Router;

    public casetype: CaseType = "request";

    constructor(
        @Inject('$uibModal') $modal: angular.ui.bootstrap.IModalService,
        @Inject() serviceCaseService: ServiceCaseService,
        @Inject() isProcessingService: IsProcessingService,
        @Inject() TranslationService: TranslationService,
        @Inject() $auth: AuthenticationService,
        @Inject('$q') $q: ng.IQService,
        @Inject() cacheService: CacheService,
        @Inject('$timeout') $timeout: ng.ITimeoutService,
        @Inject('$scope') $scope: ng.IScope,
        @Inject('$rootScope') $rootScope: angular.IRootScopeService,
        @Inject('ConversationSettings') conversationSettings: ConversationSettings,
        @Inject() logService: LogService,
        @Inject() dialogService: DialogService,
        @Inject() saveDialog: SaveDialog,
        @Inject('$element') $element: ng.IRootElementService,
        @Inject() authorizationService: AuthorizationService,
        @Inject('hotkeys') hotkeys: ng.hotkeys.HotkeysProvider,
        @Inject(FileService.selector) fileService: FileService,
        @Inject(UserService.selector) userService: UserService,
        @Inject('$rootRouter') private $rootRouter: ng.Router,
    ) {
        super(authorizationService, serviceCaseService, isProcessingService, TranslationService, $auth, $q, cacheService, $timeout, $modal, conversationSettings, logService, dialogService, saveDialog, $scope, $rootScope, $element, hotkeys, fileService, userService);
    }

    protected onInit() {
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        this.minDeadline = today;
        this.Base.Title = "REQUEST_NO";
        this.Base.highlightMenuItem = 'request';
    }

    onDestroy() {
        this.Base.Title = '';
        this.Base.highlightMenuItem = '';
    }

    protected async loadData() {
        var data = this.ServiceCase;
        this.application.forcedCustomer = (await this.application.customers).filter(x => x.key == data.customer.href.replace('customer/', '')).map(c => c.text).pop();
        this.deadlineDT = data.requestedDeadline ? new Date(data.requestedDeadline) : null;
        this.statuslinks = this.ServiceCase.actionLinks && this.ServiceCase.actionLinks.statusLinks ? Object.keys(this.ServiceCase.actionLinks.statusLinks).map<StatusButton>(x => { return { id: x, name: "act_" + x, tooltipname: x } }) : [];
        this.feedbackLinks = this.ServiceCase.actionLinks && this.ServiceCase.actionLinks.feedbackStatusLinks ? Object.keys(this.ServiceCase.actionLinks.feedbackStatusLinks).map<FeedbackStatusLink>(l => { return { id: l, name: "act_feedback_" + l, act: this.ServiceCase.actionLinks.feedbackStatusLinks[l].action } }) : [];
        await Promise.all([
            this.GetHistoryAndCorrespondence(),
            this.GetFiles()
        ]);
    }

    protected async ReloadServiceCase() {
        if (this.ServiceCase.type != 'request') {
            this._propertiesTabDirty = false;
            this.setDirty();
            this.$rootRouter.navigate(['Problem', 'Edit', { number: this.ServiceCase.caseNumber }]);
        }
        else
            super.ReloadServiceCase();
    }


    private async onNewAttachment(file: CaseFileData) {
        if (this.readOnly)
            return;
        this.AddNewAttachment(file);
    }

    async onPriorityChanged(priority: any) {
        if (this.readOnly)
            return;
        if (!this.loadingData) {
            if (this.ServiceCase.priority != priority) {
                this.ServiceCase.priority = priority;
                this.isProcessingService.StartProcessing();
                try {
                    await this.serviceCaseService.UpdateRequest(this.ServiceCase.id, this.ServiceCase);
                    await this.ReloadServiceCase();
                } catch (error) {
                    if (ServiceUtils.IsUnauthorizedResponse(error))
                        return;
                    this.application.setSeqUrl(error);
                    this.dialogManager.showErrorDialog('error', 'ERROR', 'EDIT_PRIORITY_REQUEST_ERROR', { errorResult: error, translate: true });
                } finally { this.isProcessingService.StopProcessing(); };
            }
        }
    }

    public get minDeadline(): Date {
        return (this.deadlineToolboxIsOpen) ? this._deadlineThreshold : this._minDeadline;
    }
    public set minDeadline(value: Date) {
        this._minDeadline = value;
        this._deadlineThreshold = value.addDays(7);
    }
    public async OnDateChanged(date: Date) {
        if (this.readOnly || date === undefined)
            return;
        if (!this.loadingData
            && this.ServiceCase
            && this.ServiceCase.status != "closed"
            && await this.checkDeadlineChange(date)
        ) {
            this.deadlineDT = date;
            this.ServiceCase.requestedDeadline = date ? date.toISODateString() : null;
            this.isProcessingService.StartProcessing();
            try {
                await this.serviceCaseService.UpdateRequest(this.ServiceCase.id, this.ServiceCase);
                if (this.deadlineRemark && this.deadlineRemark.length > 1) {
                    this.AddCorrespondence(this.deadlineRemark, false);
                    this.deadlineRemark = null;
                }
                await this.ReloadServiceCase();
            } catch (error) {
                if (ServiceUtils.IsUnauthorizedResponse(error))
                    return;
                this.application.setSeqUrl(error);
                this.dialogManager.showErrorDialog('error', 'ERROR', 'EDIT_DEADLINE_REQUEST_ERROR', { errorResult: error, translate: true });
            }
            finally { this.isProcessingService.StopProcessing(); };
        } else {
            var deadLine = this.deadlineDT ? this.deadlineDT.clone() : null
            this.deadlineDT = deadLine ? undefined : Date.today().addDays(7);
            await this.$timeout();
            this.deadlineDT = deadLine;
        }
    }

    public async HandleFeedback(feedback: string, status: FeedbackStatusLink) {
        if (this.readOnlyChat)
            return;
        if (!this.loadingData) {
            return this.AddFeedback(feedback, status);
        }
    }

    public async HandleNewConversationEntry(entry: string, internal: boolean) {
        if (this.readOnlyChat)
            return;
        if (!this.loadingData) {
            await this.AddCorrespondence(entry, true, internal);
        }
    }
}
